/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { etoileActions } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_033: Question = {
  id: 'pres-033-actions-connaissances-especes',
  oldId: '47',
  title: 'Actions réalisées pour augmenter les connaissances sur les espèces à statut',
  number: '3.17',
  description: ['Sauf études réalisées dans le cadre de projet de développement'],
  type: QuestionType.INDICATOR,
  frequency: 1,
  slots: [
    {
      type: SlotTypes.ETOILES,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data:number) => {
        if (data >= 3) return 3;
        if (data >= 2) return 2;
        if (data >= 1) return 1;
        return 0;
      },
      score: '0',
      maxScore: 3,
      help: etoileActions,
      unit: SlotUnit.NUMBER_OF,
    },
  ],
};

const question_pres_033__v3: Question = {
  ...question_pres_033,
  title: 'Actions réalisées pour augmenter les connaissances sur les espèces en situation précaire',
  number: '3.7',
};

export const question_pres_033_v2: Question = question_pres_033;
export const question_pres_033_v3: Question = question_pres_033__v3;
